<template>
    <div>
      <info-box v-bind:description="description"></info-box>
      <header-title title="EQUIPPED ITEMS" />
  
      <div v-if="currentUser" :style="{maxHeight: '85%'}" style="overflow-y: auto;">
        <div class="rate-title">
          <div :style="{fontSize: '1.5rem', fontWeight: 700}">Your Rate</div>
        </div>

        <div class="">
          <div class="inventory-container">
            <div class="slot-grid">
                <div class="slot-cell">
                    <img src="path/to/your/slot-item1.png" alt="Slot Item 1">
                </div>
                <!-- <div class="slot-cell active">
                    <img src="path/to/your/slot-item2.png" alt="Slot Item 2">
                </div> -->
                <!-- Add more slot cells as needed -->
            </div>
            
            <div class="inventory-grid">
                <div class="inventory-item">
                    <img src="path/to/your/inventory-item1.png" alt="Inventory Item 1">
                </div>
                <!-- <div class="inventory-item active">
                    <img src="path/to/your/inventory-item2.png" alt="Inventory Item 2">
                </div> -->
                <!-- Add more inventory items as needed -->
            </div>
        </div>
        </div>
      </div>
      <span v-else><login-btn buttonClass="btn-enabled" style="font-size: 40px; padding: 8px;">Login to View Equipped Items!</login-btn></span>
    </div>
  </template>
  
  <script>
  import { mapState, mapActions } from 'vuex'
  export default {
    name: 'equipped-items',
    computed: {
      ...mapState(['userRates', 'currentUser'])
    },
    data () {
      return {
        description: {
          title: 'Loot Shop',
          text: `Spend SwiftBUCKS and SwiftGOLD on awesome loot!`
        }
      }
    },
    methods: {
      ...mapActions({
        // fetchUserRates: 'fetchUserRates'
      })
    },
    mounted () {
    },
    watch: {
      currentUser () {
        this.$nextTick(() => {
        })
      }
    }
  }
  </script>
  
  <style scoped>
  .rate-title{
    background: var(--sl-red);
    display: inline-block;
    margin: auto;
    padding: 1rem 2rem;
    border-radius: 1rem;
  }
  
  .rates-cont{
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin: 1rem auto;
    max-width: 50rem;
  
  }
  .rate-box{
    background: #00000088;
    padding: .8rem 1.2rem;
    border-radius: .5rem;
  }
  .rate-info{
    display: flex;
    justify-content: space-between;
    justify-items: center;
    gap: 1rem;
    width: 100%;
  }
  .rate-info>.title{
    font-size: 1.8rem;
    font-weight: 700;
    margin: none;
  }
  .rate-info>.rate-val{
    font-size: 1.5rem;
  }
  .rate-box>.rate-desc{
    width: 100%;
    padding-top: 1rem;
    margin-top: 1rem;
    border-top: 1px gray solid;
    font-size: .8rem;
    color: gray;
    text-align: left;
  }
  .rate-box>.rate-desc a{
    text-decoration: underline;
    color: var(--sl-red);
  }

/* Container for Both Grids */
.inventory-container {
    display: flex;
    justify-content: space-between; /* Distributes space between the two grids */
    gap: 20px; /* Space between the two grids */
    padding: 20px;
}

/* Slot Grid Styles */
.slot-grid {
    flex: 1; /* The slot grid will take up one part of the container */
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 15px;
    padding: 20px;
    background-color: rgba(0, 0, 0, 0.9); 
    border-radius: 10px;
}

/* Inventory Grid Styles */
.inventory-grid {
    flex: 1; /* The inventory grid will take up one part of the container */
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 15px;
    padding: 20px;
    background-color: rgba(10, 10, 10, 0.95); 
    border-radius: 10px;
    overflow-y: auto;
    max-height: 600px;
}

/* Slot Cell and Inventory Item styles */
.slot-cell, .inventory-item {
    width: 100px;
    height: 100px;
    border-radius: 8px;
    background-color: rgba(20, 20, 20, 0.8); 
    box-shadow: 0px 0px 15px 2px #00FFFF, inset 0px 0px 10px 2px #00FFFF; 
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    cursor: pointer;
}



/* Slot Cell Hover Effect */
.slot-cell:hover {
    transform: scale(1.05);
    box-shadow: 0px 0px 25px 5px #00FFFF, inset 0px 0px 15px 3px #00FFFF;
}

/* Slot Cell Icon */
.slot-cell img {
    max-width: 80%;
    max-height: 80%;
    filter: drop-shadow(0px 0px 5px #00FFFF); /* Neon glow around the icon */
}

/* Slot Cell Active State */
.slot-cell.active {
    border-color: #FF00FF; /* Neon magenta border for active state */
    box-shadow: 0px 0px 25px 5px #FF00FF, inset 0px 0px 15px 3px #FF00FF;
}


/* Inventory Item Hover Effect */
.inventory-item:hover {
    transform: scale(1.05);
    box-shadow: 0px 0px 15px 3px #00FFAA, inset 0px 0px 10px 2px #00FFAA;
}

/* Inventory Item Icon */
.inventory-item img {
    max-width: 80%;
    max-height: 80%;
    filter: drop-shadow(0px 0px 5px #00FFAA); /* Neon glow around the icon */
}

/* Inventory Item Active State */
.inventory-item.active {
    border-color: #FF00FF; /* Neon magenta border for active state */
    box-shadow: 0px 0px 25px 5px #FF00FF, inset 0px 0px 15px 3px #FF00FF;
}
  </style>


// WEBPACK FOOTER //
// src/components/Equipped-Items.vue